import {
  Handover,
  HandoverOperationResult,
  HandoversHistory,
  HandoversTotalCount,
  ResultHandovers,
  ResultHandoversHome,
} from 'src/app/interfaces/handover';
import { HANDOVER_TYPES_AREA_REASON } from './mock-handover-types-area-reason';
import { WELLS } from './mock-wells';

export const HANDOVERS: Handover[] = [
  {
    handoverId: 1234,
    handoverTypeAreaReasonId:
      HANDOVER_TYPES_AREA_REASON[0].handoverTypeAreaReasonid,
    handoverType: HANDOVER_TYPES_AREA_REASON[0].type,
    wellId: WELLS[0].wellId,
    wellUwi: WELLS[0].uwi,
    wellName: WELLS[0].wellCommonName,
    creationDate: new Date(),
    creatorUser: 'Juan Pérez',
    daysOfCreation: 1,
    fromAreaName: HANDOVER_TYPES_AREA_REASON[0].fromAreaName,
    toAreaName: HANDOVER_TYPES_AREA_REASON[0].toAreaName,
    handoverStatusId: 1,
    handoverStatusName: 'Creado',
    wellManagementUnitId: 1,
    hasSectionsComments: true,
  },
];

export const RESULT_HANDOVERS: ResultHandovers = {
  handovers: HANDOVERS,
  totalHandovers: 1500,
};

export const HANDOVERS_PENDIENTE_TOMAR: Handover[] = [
  {
    handoverId: 4321,
    handoverTypeAreaReasonId:
      HANDOVER_TYPES_AREA_REASON[0].handoverTypeAreaReasonid,
    handoverType: HANDOVER_TYPES_AREA_REASON[0].type,
    wellId: WELLS[1].wellId,
    wellUwi: WELLS[1].uwi,
    wellName: WELLS[1].wellCommonName,
    creationDate: new Date(),
    creatorUser: 'Juan Pérez',
    daysOfCreation: 1,
    fromAreaName: HANDOVER_TYPES_AREA_REASON[0].fromAreaName,
    toAreaName: HANDOVER_TYPES_AREA_REASON[0].toAreaName,
    handoverStatusId: 2,
    handoverStatusName: 'Pendiente para tomar',
    wellManagementUnitId: 1,
    hasSectionsComments: false,
  },
];

export const RESULT_HANDOVERS_PENDIENTE: ResultHandovers = {
  handovers: HANDOVERS_PENDIENTE_TOMAR,
  totalHandovers: 100,
};

export const RESULT_HANDOVERS_HOME: ResultHandoversHome = {
  handoversGeneral: RESULT_HANDOVERS_PENDIENTE,
  handoversSentPersonal: RESULT_HANDOVERS_PENDIENTE,
  handoversEdition: RESULT_HANDOVERS,
  handoversInboxPersonal: RESULT_HANDOVERS,
  handoversRejectedPersonal: RESULT_HANDOVERS,
  handoversInboxTeam: RESULT_HANDOVERS,
  handoversInboxEditionTeam: RESULT_HANDOVERS,
  handoversRejectedTeam: RESULT_HANDOVERS,
  handoversSentTeam: RESULT_HANDOVERS,
};

export const HANDOVER_SEND_PENDIENTE: HandoverOperationResult = {
  handover: HANDOVERS_PENDIENTE_TOMAR[0],
  notificationSent: true,
  notificationWellIntegrity: true,
  ho3skipNotification: false,
};

export const HANDOVERS_HISTORY: HandoversHistory = {
  totalAmountOfHandovers: 12,
  handoversListDetails: [
    {
      handoverId: 1,
      firstSendDate: new Date('09/16/2020'),
      handoverTypeName: 'HO1',
      fromAreaName: 'Completion & Workover',
      toAreaName: 'Operations',
      acceptedDate: new Date('09/20/2020'),
      haveObservations: false,
    },
    {
      handoverId: 2,
      firstSendDate: new Date('10/09/2020'),
      handoverTypeName: 'HO3',
      fromAreaName: 'Operations',
      toAreaName: 'Completion & Workover',
      acceptedDate: new Date('10/12/2020'),
      haveObservations: false,
    },
    {
      handoverId: 3,
      firstSendDate: new Date('11/04/2020'),
      handoverTypeName: 'HO4',
      fromAreaName: 'Pulling',
      toAreaName: 'Operations',
      acceptedDate: new Date('11/09/2020'),
      haveObservations: false,
    },
    {
      handoverId: 4,
      firstSendDate: new Date('03/28/2020'),
      handoverTypeName: 'HO3',
      fromAreaName: 'Operations',
      toAreaName: 'Pulling',
      acceptedDate: new Date('04/07/2020'),
      haveObservations: true,
    },
    {
      handoverId: 5,
      firstSendDate: new Date('11/14/2019'),
      handoverTypeName: 'HO4',
      fromAreaName: 'Pulling',
      toAreaName: 'Operations',
      acceptedDate: new Date('11/20/2019'),
      haveObservations: true,
    },
    {
      handoverId: 6,
      firstSendDate: new Date('07/11/2019'),
      handoverTypeName: 'HO3',
      fromAreaName: 'Operations',
      toAreaName: 'Pulling',
      acceptedDate: new Date('07/16/2019'),
      haveObservations: false,
    },
  ],
};

export const HANDOVERS_TOTAL_COUNT: HandoversTotalCount = {
  totalAmount: 12,
};
